import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface TopbarContext {
  title: string;
  badge?: string;
  subtitle?: string;
  actions?: TopbarAction[];
}

export interface TopbarAction {
  icon: string;
  tooltip: string;
  type: 'default' | 'danger' | 'warning' | 'favorite-on' | 'favorite-off';
  callback: () => void;
  /** Estado activo (toggle), ej. mientras el modal asociado está abierto. */
  active?: boolean;
}

@Injectable({ providedIn: 'root' })
export class TopbarContextService {
  private context = new BehaviorSubject<TopbarContext | null>(null);
  readonly context$ = this.context.asObservable();

  /** Set custom context (e.g., company detail view) */
  set(ctx: TopbarContext): void {
    this.context.next(ctx);
  }

  /** Clear custom context (reverts to default page title) */
  clear(): void {
    this.context.next(null);
  }
}
